/**
 * url Config for de cluttering endpoints so that we can change it in one place and it will reflect
 * across the whole code base, eventually we can make one for prod but just dev for right now
 * stgWacInternalUrl(formerly): "qa-wac.internal.atlassian.com"
 */


export const stgConfig = {
  stgWacInternalUrl: "https://wac.stg.internal.atlassian.com"
};

export default stgConfig;
